module.exports = __webpack_public_path__ + "img/dhl.fb8df2c4.jpg";